var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "demo" }, [
      _c("div", { staticClass: "chartBar", attrs: { id: "checkInType" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }